const editAboutUsConstantsAr = {
  AboutUsPageTitle: 'من نحن',
  AboutUsBreadcrumb: 'من نحن',
};

export default editAboutUsConstantsAr;
